export default "__VITE_ASSET__BWC35_j3__"